// 负责订单结果页展示，与订单状态机输出和继续购物流程关联。
import type { Order } from "../../domain/orders";
import { OrderSummary } from "./OrderSummary";

type OrderResultViewProps = {
  order: Order;
  onContinueShopping: () => void;
};

export const OrderResultView = ({
  order,
  onContinueShopping
}: OrderResultViewProps) => {
  return (
    <main className="flow-shell">
      <section className="result-workspace" aria-label="Order result">
        <div className={`result-banner ${order.paymentStatus}`}>
          <p>Order {order.id}</p>
          <h1>{getResultTitle(order)}</h1>
          <span>{getResultCopy(order)}</span>
        </div>

        <div className="checkout-grid">
          <OrderSummary order={order} />
          <section className="next-step-panel">
            <h2>Next step</h2>
            <p>
              Payment status is now <strong>{order.paymentStatus}</strong>.
              Fulfillment status remains{" "}
              <strong>{order.fulfillmentStatus}</strong> for manual operations.
            </p>
            <button
              className="primary-button"
              type="button"
              onClick={onContinueShopping}
            >
              Continue shopping
            </button>
          </section>
        </div>
      </section>
    </main>
  );
};

// 根据支付状态生成结果页标题。
const getResultTitle = (order: Order): string => {
  if (order.paymentStatus === "paid") {
    return "Payment simulated successfully.";
  }

  if (order.paymentStatus === "failed") {
    return "Payment simulation failed.";
  }

  if (order.paymentStatus === "cancelled") {
    return "Payment simulation cancelled.";
  }

  if (order.paymentStatus === "expired") {
    return "Payment session expired.";
  }

  return "Payment is still pending.";
};

// 根据支付状态生成结果页说明。
const getResultCopy = (order: Order): string => {
  if (order.paymentStatus === "paid") {
    return "The cart was cleared and the order is ready for manual fulfillment testing.";
  }

  if (order.paymentStatus === "failed") {
    return "The order remains visible for debugging and the cart can be retried.";
  }

  if (order.paymentStatus === "cancelled") {
    return "The buyer cancelled checkout before money movement would happen.";
  }

  if (order.paymentStatus === "expired") {
    return "The session reached an expired state to test timeout handling.";
  }

  return "No payment event has been applied yet.";
};
